import axios from "axios";
import { TOKEN, USER_ID } from "../types";

// API Endpoints from environment variables
const API_ENDPOINT = process.env.REACT_APP_API_ENDPOINT || "https://ekyc-apiv2.paymeindia.in";
const PAYME_API_ENDPOINT = process.env.REACT_APP_PAYME_API_ENDPOINT || "https://apiv2.paymeindia.in";
const VIDEO_VERIFICATION_URL = process.env.REACT_APP_VIDEO_VERIFICATION_URL || "https://rat.paymeindia.in";
const FACE_LIVENESS_API_ENDPOINT = process.env.REACT_APP_FACE_LIVENESS_API_ENDPOINT;

export const setToken = (token) => {
  return (dispatch) => {
    dispatch({
      type: TOKEN,
      payload: token,
    });
  };
};

export const setUserId = (dispatch , user_id) => {
    dispatch({
      type: USER_ID,
      payload: user_id,
    });
};

export const preSignedUrl = ( data,token ) => {
  let url = `${API_ENDPOINT}/api/ekyc/v2/selfie/get-post-signed-url/`;
  let config = {
    headers: {
        Authorization :  token,
        'Content-Type': 'application/json'

      }
  }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url,data,config)
        .then((response) => {
          return resolve(response.data.presigned_url);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const uploadDocsToS3 = ({ url, formData }) => {
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, formData)
        .then((result) => {
          return resolve(result);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

// export const aadharImageVerify = ({ data }) => {
//   let url = `${API_ENDPOINT}/process-offline-kyc/aadhar-verify/`;
//   return (dispatch) =>
//     new Promise((resolve, reject) => {
//       axios
//         .post(url, data, config)
//         .then((response) => {
//           return resolve(response);
//         })
//         .catch((err) => {
//           return reject(err.message);
//         });
//     });
// };

// export const panImageVerify = ({ data }) => {
//   let url = `${API_ENDPOINT}/process-offline-kyc/pan-verify/`;
//   return (dispatch) =>
//     new Promise((resolve, reject) => {
//       axios
//         .post(url, data)
//         .then((result) => {
//           return resolve(result);
//         })
//         .catch((err) => {
//           return reject(err);
//         });
//     });
// };

// export const selfieVerify = ({ data }) => {
//   let url = `${API_ENDPOINT}/process-offline-kyc/selfie-verify/`;
//   return (dispatch) =>
//     new Promise((resolve, reject) => {
//       axios
//         .post(url, data)
//         .then((result) => {
//           return resolve(result);
//         })
//         .catch((err) => {
//           return reject(err);
//         });
//     });
// };

export const getUserId = ({ token }) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/get-basic-info-by-token/`;
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.get(url, {
        headers: {
          Authorization: token
        },
      })
      .then((res) => {
          setUserId(dispatch,  USER_ID)
          return resolve(res)
      })
      .catch((err) => {
          return reject(err)
      })
    });
};
export const aadhaarSendOtp = ( data,token ) => {
  let testUrl="https://ekyc-apiv2.paymeindia.in"
  let url =
    `${testUrl}/api/ekyc/v2/aadhaar-init/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url, data, config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err.response)
      })
    });
};

export const kycStatusCheck = (token ) => {
  let testUrl="https://ekyc-apiv2.paymeindia.in"
  let url =
    `${testUrl}/api/ekyc/v2/get-eaadhaar/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.get(url, config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err.response)
      })
    });
};

export const aadhaarVerifyOtp = ( data,token ) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/aadhaar_verify_otp/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url, data, config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err.response)
      })
    });
};
export const checkFatherName = ( token ) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/pan/check_father_name/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.get(url, config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err.response)
      })
    });
};
export const panVerify = ( data,token ) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/pan/verify/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url, data,config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err)
      })
    });
};  
export const checkImage = ( token ) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/selfie/check_image/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.get(url,config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err)
      })
    });
};
export const selfieVerify = ( data,token,is_ckyc) => {
  let url = is_ckyc? `${API_ENDPOINT}/api/ekyc/v2/ckyc/selfie_verify/`: `${API_ENDPOINT}/api/ekyc/selfie/verify/`
  
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url,data,config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
          return reject(err)
      })
    });
};    
export const ckycVerify = (token,pan_data) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/v2/ckyc/send-otp/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url,pan_data,config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
        return reject (err.response);
      })
    });
};  
export const ckycVerifyOtp = (data,token) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/v2/ckyc/selfie_verify/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url,data,config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((error) => {
        return reject (error);
      })
    });
}; 

export const ckycResendOtp = (token) => {
  let url =
    `${API_ENDPOINT}/api/ekyc/ckyc/resend_otp/`;
    let config = {
      headers: {
          Authorization :  token,
          'Content-Type': 'application/json'
  
        }
    }
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios.post(url,{},config
      )
      .then((res) => {
          return resolve(res)
      })
      .catch((err) => {
        return reject (err);
      })
    });
}; 

export const getPincodeDetails = (pincode, token) => {
  let url = `${API_ENDPOINT}/api/ekyc/user/pincode_details/`;
  let config = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, { pincode }, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const getVideoKyc = (userId) => {
  const url = `${VIDEO_VERIFICATION_URL}/api/v1/challenge/generate?user_id=${userId}`
  return axios.post(url, {
    headers: {
      "Content-Type": "application/json",
      "Authorization": ""
    },
  });
};

export const videoVeify = (params) => {
  const url = `${VIDEO_VERIFICATION_URL}/api/v1/challenge/verify`
  return axios.post(url, params,{
    headers: {
      "Content-Type": "application/json",
      "Authorization": ""
    },
  });
};

export const getAddressDetails = (token) => {
  // console.log(token, "action_inside");

  let url = `${API_ENDPOINT}/api/ekyc/user/address/`;
  let config = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((res) => {
          return resolve(res);
        })
        .catch((err) => {
          return reject(err); 
        });
    });
};



export const updateAddressDetails = (token, presentAddressData) => {
  let url = `${API_ENDPOINT}/api/ekyc/user/address/`;
  let config = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, presentAddressData, config)
        .then((res) => {
          return resolve(res);  
        })
        .catch((err) => {
          return reject(err);  
        });
    });
};

export const phoneVerify = (params) => {
  const url = `${API_ENDPOINT}/api/ekyc/v2/ckyc/selfie_verify/`
  return axios.post(url,params, {
    headers: {
      "Content-Type": "application/json",
      "Authorization":  params?.token
    }
  });
};
export const resendOtp = (token,params) => {
  const url = `${API_ENDPOINT}/api/ekyc/v2/ckyc/resend_otp/
  `
  return axios.post(url,params, {
    headers: {
      "Content-Type": "application/json",
      "Authorization":token
    }
  });
};

export const otpVerify = (params) => {
  const url = `${API_ENDPOINT}/api/ekyc/v2/ckyc/verify-otp/`
  return axios.post(url,params, {
    headers: {
      "Content-Type": "application/json",
      "Authorization":  params?.token
    }
  });
};

// AWS Face Liveness Actions
export const createLivenessSession = (token) => {
  let url = `${FACE_LIVENESS_API_ENDPOINT}/generate-session`;
  let config = {
    headers: {
      Authorization: process.env.REACT_APP_FACE_LIVENESS_TOKEN,
      'Content-Type': 'application/json'
    }
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((response) => {
          // API returns { session_id: "..." }, convert to sessionId for consistency
          return resolve({
            sessionId: response.data.session_id
          });
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const verifyLivenessSession = (data, token) => {
  let url = `${FACE_LIVENESS_API_ENDPOINT}/get-liveliness-result?session_id=${data.sessionId}`;
  let config = {
    headers: {
      Authorization: process.env.REACT_APP_FACE_LIVENESS_TOKEN,
      'Content-Type': 'application/json'
    }
  };
  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .get(url, config)
        .then((response) => {
          return resolve(response);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};

export const selfieLiveness = (data, token) => {

  let url = `${API_ENDPOINT}/api/ekyc/selfie/liveness/`;
  let config = {
    headers: {
      Authorization: token,
      'Content-Type': 'application/json',
    },
  };

  return (dispatch) =>
    new Promise((resolve, reject) => {
      axios
        .post(url, data, config)
        .then((res) => {
         
          return resolve(res);
        })
        .catch((err) => {
          return reject(err);
        });
    });
};
